import { render, staticRenderFns } from "./Rest.vue?vue&type=template&id=3f8daedc&scoped=true"
import script from "./Rest.vue?vue&type=script&lang=js"
export * from "./Rest.vue?vue&type=script&lang=js"
import style0 from "./Rest.vue?vue&type=style&index=0&id=3f8daedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8daedc",
  null
  
)

export default component.exports